import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios.ts';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { Notification } from 'src/features/parkingManagement/types/notifications.ts';

const RESOURCE = '/parkings/:parkingId/parking-notification-settings/';

export type CreateNotificationSettingsFnType = typeof createNotificationSettings;

export type DTO = {
    parkingId: string;
};

const createNotificationSettings = ({ parkingId, ...data }: DTO): Promise<Omit<Notification, 'id'>> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateNotificationSettingsOptions
    extends MutationConfig<CreateNotificationSettingsFnType, GeneralSmartParkError> {}

export const useCreateNotificationSettings = (options: UseCreateNotificationSettingsOptions) =>
    useMutation({
        mutationFn: createNotificationSettings,
        ...options,
    });
